export default __webpack_public_path__ + "static/media/chipstack_main.8de69d6b.png";